import template from './DataGroupPage.html'

const dataGroupPage = {
  bindings: {
    user: '<'
  },
  template,
  controller: /* @ngInject */ class DataGroupPageController {
    constructor (StoreService, $state, $location) {
      this.StoreService = StoreService
      this.$state = $state
      this.$location = $location
      this.urlParams = this.$state.params
    }
  }
}

export default dataGroupPage
